import React from 'react';
import { T } from '../../../../../../../../../common/locale/translate';

const Categories = props => (
  <div className="offer-categories">
    {props.data.is_allinclusive && (
      <span className="offer-category all-inclusive">
        {' '}
        {T('all_inclusive')}{' '}
      </span>
    )}
    {props.data.is_lastminute && (
      <span className="offer-category last-minute"> {T('last_minute')} </span>
    )}
    {props.data.is_firstminute && (
      <span className="offer-category first-minute"> {T('first_minute')} </span>
    )}
  </div>
);

export default Categories;



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/with-hotel/components/categories.js